module.exports = __webpack_public_path__ + "img/icon-remove-upload.094fbd79.svg";